module.exports = __webpack_public_path__ + "img/9.bb334131.jpg";